export default __webpack_public_path__ + "static/media/92.afa479f0.png";